export enum PreviewType {
    // Meshes
    Sphere,
    Box,
    Cylinder,
    Plane,
    ShaderBall,

    Custom,

    // Env
    Room,
}
